// extracted by mini-css-extract-plugin
export var wordContainer = "_qc-0";